import { DataPilot } from '@/modules/data-pilot/types';
import { UserRoles } from '@/enums';

const access_roles = {
  [DataPilot.Pages.DATA_PILOT]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.CLIENT_MANAGER,
  ],
};

export default access_roles;
